// D07 (spec d07-v01.1 §1.3): depois que "Carregar mais" (fila) ou "Veja mais" (linha do tempo) carregam, o foco do
// TECLADO não se perde (o botão clicado é substituído pela resposta). Clique de mouse não mexe no foco.
// Ativação por teclado: keydown Enter/Espaço no .tk-mais, ou click com event.detail === 0.
// Observer childList (sem subtree) de uso único no rodapé daquele clique; desliga na 1ª troca ou em 60 s.
// O número da página anexada (fila) sai do `pag` da data-ajax ANTES da troca (parecer d07, ressalva Front 2).
// Sem tocar no JS global; sem preventDefault (o .bt-ajax do botão segue).

const MaisFoco = function () {

    let vigia = null;
    let teto = null;
    const soltar = () => { if (vigia) { vigia.disconnect(); vigia = null; } clearTimeout(teto); teto = null; };

    const focar = (el) => { if (el) el.focus({ preventScroll: true }); };

    const aposTroca = (rodape, pag) => {
        const novo = rodape.querySelector('.tk-mais');
        if (novo) { focar(novo); return; }   // há mais, ou erro com o mesmo botão
        if (rodape.id === 'tk-fila-rodape') {
            const pagina = pag ? document.getElementById('tk-fila-pag-' + pag) : null;
            focar(pagina ? pagina.querySelector('.tk-item .tk-item-abrir') : null);   // fim da fila
            return;
        }
        const fim = rodape.querySelector('.tk-mais-fim');   // fim da linha do tempo
        if (fim) { fim.setAttribute('tabindex', '-1'); focar(fim); }
    };

    const armar = (btn) => {
        const rodape = btn.closest('#tk-fila-rodape, #tk-tl-mais');
        if (!rodape) return;
        let pag = null;
        try { pag = new URL(btn.dataset.ajax || '', location.href).searchParams.get('pag'); } catch (err) { pag = null; }
        soltar();
        vigia = new MutationObserver(() => { soltar(); aposTroca(rodape, pag); });
        vigia.observe(rodape, { childList: true });
        teto = setTimeout(soltar, 60000);
    };

    const botaoDe = (e) => (e.target instanceof Element ? e.target.closest('.tk-mais') : null);

    return {
        init: function () {
            if (!document.querySelector('.open-ticket-detail')) return;   // só na tela de tickets nova
            document.addEventListener('keydown', (e) => {
                const btn = botaoDe(e);
                if (btn && (e.key === 'Enter' || e.key === ' ')) armar(btn);
            });
            document.addEventListener('click', (e) => {
                const btn = botaoDe(e);
                if (btn && e.detail === 0) armar(btn);
            });
        },
    };
}();

module.exports = MaisFoco;
